import { DollarSign, TrendingUp, MessageSquare, BarChart3, Sparkles } from 'lucide-react';
import { KPICard } from '../KPICard';
import { ChannelEffectiveness } from '../ChannelEffectiveness';
import { MonthlyPerformanceTable } from '../MonthlyPerformanceTable';

interface RecuperacaoTabProps {
  kpiData: {
    totalRecuperado: number;
    taxaRecuperacao: number;
    melhorCanal: string;
    valorMedioRecuperado: number;
  };
}

function formatMoney(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function RecuperacaoTab({ kpiData }: RecuperacaoTabProps) {
  return (
    <div className="space-y-6">
      {/* KPIs de Recuperação */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <KPICard
          title="Total Recuperado"
          value={formatMoney(kpiData.totalRecuperado)}
          variant="accent"
          subtitle="Este mês"
          icon={<DollarSign className="h-4 w-4 text-[hsl(var(--accent-600))]" />}
        />
        <KPICard
          title="Taxa de Recuperação"
          value={`${kpiData.taxaRecuperacao}%`}
          variant="basic"
          subtitle="Média geral"
          icon={<TrendingUp className="h-4 w-4 text-[hsl(var(--basic-600))]" />}
        />
        <KPICard
          title="Melhor Canal"
          value={kpiData.melhorCanal}
          variant="neutral"
          subtitle="Maior conversão"
          icon={<MessageSquare className="h-4 w-4 text-muted-foreground" />}
        />
        <KPICard
          title="Valor Médio por Cobrança"
          value={formatMoney(kpiData.valorMedioRecuperado)}
          variant="neutral"
          subtitle="Por pagamento"
          icon={<BarChart3 className="h-4 w-4 text-muted-foreground" />}
        />
      </div>

      {/* Gráfico de Efetividade + Insight IA */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChannelEffectiveness />
        
        {/* Insight IA Card */}
        <div className="p-5 rounded-2xl border bg-gradient-to-br from-[hsl(var(--basic-50))] to-[hsl(var(--accent-50))] hover:shadow-lg transition-all duration-300">
          <div className="flex items-start gap-3 mb-4">
            <div className="p-2 rounded-xl bg-[hsl(var(--basic-100))]">
              <Sparkles className="h-5 w-5 text-[hsl(var(--basic-600))]" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground">Insight de IA</h3>
              <p className="text-xs text-muted-foreground">Análise automática de canais</p>
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="p-4 rounded-xl bg-card/80 backdrop-blur border border-border/50">
              <p className="text-sm text-foreground leading-relaxed">
                O <span className="font-bold text-[hsl(var(--accent-600))]">WhatsApp</span> apresenta 
                taxa de conversão <span className="font-bold">33% maior</span> que o Email. 
                Considere priorizar esse canal para clientes com dívidas acima de R$ 1.000.
              </p>
            </div>
            
            <div className="p-4 rounded-xl bg-card/80 backdrop-blur border border-border/50">
              <p className="text-sm text-foreground leading-relaxed">
                Envios feitos entre <span className="font-bold text-[hsl(var(--basic-600))]">9h e 11h</span> têm 
                <span className="font-bold"> 22% mais abertura</span> que outros horários.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabela de Performance Mensal */}
      <MonthlyPerformanceTable />
    </div>
  );
}
